export default "__VITE_ASSET__UiwKpOfU__"